import { SignatairePaEntity } from "./signataire-pa.entity";

export class SignatairePaOrder {
	id!: number;
	signataires: SignatairePaEntity[] = [];
}
